'use strict';

import {
    RECEIVE_TREE_DATA
} from '../constants';
import { ReceiveTreeDataAction } from "~/frontend/src/actions/loadTree";

type TreeState = Partial<{
    [ componentUid: string ] : {
        treeMetaData: any;
        metaCypherConfig: any;
    }
}>;

/**
    IMPORTANT!
    Think immutable! All changes must lead to a new object. For nested objects this means, all parent objects
    must be re-created.
    This is needed for change detection by redux.
 */
export default function treeReducer( state: TreeState = {}, action: ReceiveTreeDataAction ): TreeState {

    const { componentUid, treeMetaData, metaCypherConfig } = action;

    if (
        [
            RECEIVE_TREE_DATA
        ].includes( action.type ) ) {
        // create new state object (nested objects are kept)
        state = Object.assign( {}, state );
        state[ componentUid! ] = {
            treeMetaData,
            metaCypherConfig
        };
    }
    // initialize context data

    return state;
}
